module.exports = __webpack_public_path__ + "../resources/img/ic_arrow_down.4303b64f.svg";